import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-blue-50 relative" data-id="element-180" data-mp="1jb1sug4wmy7r">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-181" data-mp="1n9r525e7i9pt">
        <div className="text-center mb-10" data-id="element-182" data-mp="1s9dfy86kbdvg">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-blue-950 uppercase" data-id="element-183" data-mp="1s82b051ds02r">
            Your Complete <span className="text-orange-500" data-id="element-184" data-mp="1x9hv9uvqi2k3">Flight Instructor Ready</span> Package
          </h2>
          <p className="text-slate-700 text-sm md:text-base" data-id="element-185" data-mp="2271lzu9mc7sx">
            Everything You Need to Plan Less and Teach With More Structure
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-blue-950 border-2 border-orange-500 rounded-3xl p-1 relative shadow-xl shadow-blue-950/15" data-id="element-186" data-mp="7utl80am8wp8">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-orange-500 text-white font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-187" data-mp="1cr4xoatm7ps4">
            <Sparkles size={14} data-id="element-188" data-mp="25d6bs7vdy1nz" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-189" data-mp="20gz5gdz2uo5i">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-xl h-auto mx-auto mb-6" loading="lazy" data-id="element-190" data-mp="1vgbji6ppgxi5" />

            <p className="text-sm font-bold tracking-widest text-blue-600 mb-3" data-id="element-191" data-mp="k2g02lrrq2l4">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-amber-50 border border-amber-200/70 rounded-xl p-4" data-id="element-192" data-mp="g0cntux9ytys">
              {packageIncludes.map((item, itemIndex) => <li key={item.label} className="flex items-start gap-2 text-sm text-slate-800" data-id="element-193" data-mp="mhe79a9n2jxj" data-mpi={itemIndex}>
                  {itemIndex === 6 && <span className="sr-only" data-id="element-194" data-mp="7kdgpa36ov0n">Plus:</span>}
                  {item.kind === 'bonus' ? <Gift size={16} className="text-orange-500 shrink-0 mt-0.5" data-id="element-195" data-mp="chnbz6d980we" /> : <Check size={16} className="text-blue-600 shrink-0 mt-0.5" data-id="element-196" data-mp="3uvw8as15wz7n" />}
                  <span data-id="element-197" data-mp="3is5rua7mqt3">{item.label}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-198" data-mp="3kzjja7gkb9j8">
              <p className="text-sm text-slate-500 mb-1" data-id="element-199" data-mp="3kwds8modhxkv">
                REGULAR VALUE: <span className="line-through" data-id="element-200" data-mp="3py33o3ficd9h">$105 USD</span>
              </p>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-201" data-mp="3byv1d1o1sp12">
                <span className="text-2xl md:text-3xl text-slate-600" data-id="element-202" data-mp="3fzx0zjlvn33k">TODAY:</span>
                <span className="text-4xl md:text-5xl font-serif font-extrabold text-orange-500" data-id="element-203" data-mp="2xb3akqska7e8">
                  $27 USD
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-204" data-mp="2sed0ql7co819">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500" data-id="element-205" data-mp="3g95vate2ti68">
              <span className="flex items-center gap-1.5" data-id="element-206" data-mp="3bbnvptly8faw">
                <Lock size={12} className="text-blue-600" data-id="element-207" data-mp="3b91ojv2z01t7" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-208" data-mp="3p43tofzztn4y">
                <Zap size={12} className="text-blue-600" data-id="element-209" data-mp="3l1z1zmt3v0ky" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-210" data-mp="2vugrj79nbvy">
                <Wallet size={12} className="text-blue-600" data-id="element-211" data-mp="3u1m46atnsaf2" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}